import animateScrollTo from 'animated-scroll-to';
import KsModal from '../../component/common/KsModal.vue'
import {Listeners} from "../../constants/listeners";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            base: null,
            selectedTo: [],
        }
    },
    props: {
        defaultBase: {
            type: String,
            required: false
        },
    },
    mounted() {
        if (this.defaultBase) {
            this.base = this.defaultBase;
        }
        this.$emitter.on(Listeners.KS_TABLE_CLEAR_SELECTED_TO, this.clearSelectedTo);

        // Отображение уведомления об ограниченной выгрузке
        document.querySelectorAll('.download-csv').forEach(e => e.addEventListener('click', () => this.$emitter.emit(Listeners.POPUP_KS_TABLE_DEMO_OPEN)));
    },
    computed: {
        self() {
            return this;
        },
    },
    methods: {
        showAll: function () {
            document.querySelectorAll('.overflow-container').forEach((e) => {e.style.height = "auto";})
            document.querySelectorAll('.fade-out-container').forEach((e) => {e.style.display = "none"})
            document.querySelectorAll('.showalllinksspace').forEach((e) => {e.style.display = "none"})
        },
        scrollTo: function (id) {
            setTimeout(() => {
                animateScrollTo(document.getElementById(id));
            }, 0);
        },
        clearSelectedTo() {
            this.selectedTo = [];
        },
    },
    watch: {
        selectedTo(val){
            this.$emitter.emit(Listeners.KS_TABLE_CHECKBOX_SELECTED, val);
        }

    },
    components: {
        KsModal,
    },
}
